import styled from '@emotion/styled';
import React from 'react';

import colors from 'config/theme/colors';
import { createDictionary } from 'utils/ObjectUtils';

const Ribbon = styled.div`
  width: 220px;
  height: 60px;
  overflow: visible;
  position: absolute;
  left: 0;
  top: 0;

  span {
    position: absolute;
    z-index: 16;
    display: block;
    width: 350px;
    padding: 2px 0;
    background-color: ${colors['@error-color-dark']};
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.3);
    color: #fff;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    text-transform: uppercase;
    text-align: center;
    font-weight: bold;
    right: -35px;
    top: 20px;
    transform: rotate(-18deg);
  }
`;

const ENVIRONMENTS = createDictionary(
  {
    feature: 'feat',
    development: 'dev',
    acceptance: 'acc',
    test: 'test',
    production: 'prod',
  },
  ''
);

const AppEnvironment = () => (
  <Ribbon>
    <span>
      {ENVIRONMENTS[process.env.REACT_APP_ENV]} ENV - {ENVIRONMENTS[process.env.REACT_APP_API_ENV]} API
    </span>
  </Ribbon>
);

export default AppEnvironment;
